import React from 'react';

import { flagStyles } from '../settings';

const SvgAR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-192px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAR;
